(() => {
  'use strict';
  if (window.CeikaRecapScroll) { window.CeikaRecapScroll.scan(); return; }
  const instances = new Map();
  const desktop = matchMedia('(min-width:851px)');
  function bind(card) {
    if (instances.has(card)) return;
    const rail = card.closest('.ceika-build-rail,.coil-summary-rail');
    const shell = card.closest('.ceika-premium');
    const options = rail?.previousElementSibling;
    if (!rail || !options || !shell) return;
    let frame = 0, offset = null, lastScroll = window.scrollY;
    const update = () => {
      frame = 0;
      if (!card.isConnected) return;
      const travel = window.scrollY - lastScroll;
      lastScroll = window.scrollY;
      if (!desktop.matches) {
        rail.style.removeProperty('--ceika-recap-end-gap');
        card.style.removeProperty('--ceika-recap-top');
        offset = null;
        return;
      }
      const panels = [...options.querySelectorAll('.native-options-group,.coil-step')].filter(panel => panel.getClientRects().length && !panel.hidden);
      const end = panels.at(-1) || options;
      const gap = Math.max(0, options.getBoundingClientRect().bottom - end.getBoundingClientRect().bottom);
      const navigation = shell.querySelector('[data-ceika-page-navigation]');
      const viewport = window.visualViewport;
      const viewportTop = viewport?.offsetTop || 0;
      const preview = document.getElementById('PBarNextFrame');
      const previewInset = preview && getComputedStyle(preview).display !== 'none' ? 64 : 0;
      const viewportBottom = Math.min(window.innerHeight, viewportTop + (viewport?.height || window.innerHeight)) - previewInset;
      const navigationTop = navigation ? parseFloat(getComputedStyle(navigation).top) || 0 : 0;
      const topMargin = viewportTop + navigationTop + (navigation?.getBoundingClientRect().height || 0) + 20;
      const lowerTop = Math.min(topMargin, viewportBottom - card.getBoundingClientRect().height - 16);
      const top = Math.max(lowerTop, Math.min(topMargin, (offset ?? topMargin) - travel));
      offset = top;
      const topValue = `${Math.round(top * 100) / 100}px`;
      const gapValue = `${Math.round(gap * 100) / 100}px`;
      if (card.style.getPropertyValue('--ceika-recap-top') !== topValue) card.style.setProperty('--ceika-recap-top', topValue);
      if (rail.style.getPropertyValue('--ceika-recap-end-gap') !== gapValue) rail.style.setProperty('--ceika-recap-end-gap', gapValue);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new ResizeObserver(schedule);
    observer.observe(card);
    observer.observe(options);
    const navigation = shell.querySelector('[data-ceika-page-navigation]');
    if (navigation) observer.observe(navigation);
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    desktop.addEventListener('change', schedule);
    const dispose = () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      desktop.removeEventListener('change', schedule);
      instances.delete(card);
    };
    instances.set(card, dispose);
    schedule();
  }
  function scan(scope = document) {
    scope.querySelectorAll('.ceika-premium .ceika-build-rail__card,.ceika-premium .coil-order').forEach(bind);
  }
  window.CeikaRecapScroll = { scan };
  document.addEventListener('DOMContentLoaded', () => scan());
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [card, dispose] of instances) if (event.target.contains(card)) dispose();
  });
  if (document.readyState !== 'loading') scan();
})();

